import React from "react";
import BusinessSolutionHeroBanner from "./BusinessSolutionHeroBanner/BusinessSolutionHeroBanner";
import BusinessSolutionTabWidget from "./BusinessSolutionTabWidget/BusinessSolutionTabWidget";
import SwitchOverviewWidget from "./SwitchOverviewWidget/SwitchOverviewWidget";
import CashlessBusinessOverviewWidget from "./CashlessBusinessOverviewWidget/CashlessBusinessOverviewWidget";
import SecurePayOverviewWidget from "./SecurePayOverviewWidget/SecurePayOverviewWidget";
import AdvertiseBusinessOverviewWidget from "./AdvertiseBusinessOverviewWidget/AdvertiseBusinessOverviewWidget";
import DoMoreBusinessBanner from "./DoMoreBusinessBanner/DoMoreBusinessBanner";
import SEO from "../../components/seo";

import Layout from "../../components/Layout/Layout";
import "./index.css";
const BusinessSolution = () => (
    <Layout>
        <SEO
            title="PhonePe Business Solutions"
            description="Increase your sales and grow your business by partnering with PhonePe. Get more customers to your store, enable easy payments on your website/app, increase your users with PhonePe Switch and advertise to millions of users on PhonePe."
            url="https://www.phonepe.com/business-solutions/"
        />
        <BusinessSolutionHeroBanner />
        <BusinessSolutionTabWidget />
        <SwitchOverviewWidget />
        <CashlessBusinessOverviewWidget />
        <SecurePayOverviewWidget />
        <AdvertiseBusinessOverviewWidget />
        <DoMoreBusinessBanner />
    </Layout>
);

export default BusinessSolution;
